export const CHECKOUT_ERROR_EVENT = 'payments:stripe-checkout:error'
export const CHECKOUT_CLEAR_ERROR_EVENT = 'payments:stripe-checkout:clear-error'
